import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin, Select } from 'antd';
import { type AppDispatch } from '../../../redux/store';
// import { getBranchAction } from '../../InterestScheme/store/interestSchemeActions';
import { getUnpledgedLoansAction } from '../../Loan/store/loanActions';
import { resetUnpledgedLoans } from '../../Loan/store/loanReducer';

export const UnpledgedLoansIndex = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [branchOptions, setBranchOptions] = useState<
    Array<{
      label: string;
      value: string;
    }>
  >([]);

  useEffect(() => {
    const branches = localStorage.getItem('branches');
    if (branches != null) {
      const parsedBranches = JSON.parse(branches);
      const branchOptionTemp: Array<{ label: string; value: string }> =
        parsedBranches.map((branch: { code: string; id: string }) => ({
          label: branch.code,
          value: branch.id,
        }));
      setBranchOptions(branchOptionTemp);
    }
  }, []);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const [branchOptions, setBranchOptions] = useState<SelectOption[]>(branches);
  const [value, setValue] = useState<string>('');

  const { unpledgedLoans }: any = useSelector<any>((state) => state?.loan);

  // const getFormDetails = async (): Promise<void> => {
  //   await getBranchAction(dispatch, {});
  // };

  const getUnpledgedLoans = async (): Promise<void> => {
    setIsLoading(true);
    await getUnpledgedLoansAction(dispatch, { branch: value });
    setIsLoading(false);
  };

  // useEffect(() => {
  //   void getFormDetails();
  // }, []);

  useEffect(() => {
    if (value === '') {
      resetUnpledgedLoans();
    } else {
      void getUnpledgedLoans();
    }
  }, [value]);

  // useEffect(() => {
  //   const branchOptionTemp: Array<{ label: string; value: string }> =
  //     branches.map((x: Branch) => {
  //       return {
  //         label: x.branch,
  //         value: x.branch,
  //       };
  //     });
  //   setBranchOptions(branchOptionTemp);
  // }, [branches]);

  return (
    <div>
      <Spin spinning={isLoading} fullscreen />
      <h4>Branch</h4>
      <Select
        style={{ width: 311, height: 56 }}
        placeholder="Select branch"
        onChange={(selectedvalue: string): void => {
          setValue(selectedvalue);
        }}
        options={branchOptions}
        // options={[{ value: 'krr', label: 'KRR' }]}
        className="deposit__select"
      />
      {value !== '' && unpledgedLoans.length === 0 && (
        <p>No unpledged loans found for this branch</p>
      )}
      {value.length > 0 && (
        <div
          style={{
            marginTop: 100,
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
          }}
        >
          {unpledgedLoans.map((x: any) => (
            <div
              key={x}
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: 16,
                alignItems: 'center',
              }}
            >
              <a
                href={`/customer?loanNumber=${x.loanNumber}`}
                style={{
                  color: '#DD1E2D',
                  cursor: 'pointer',
                  textDecoration: 'none',
                }}
              >
                {x.loanNumber}
                {x.loansPledged === 'partial' ? '*' : ''}
              </a>
              <p>
                {x.customerDetails.customerId} ({x.customerDetails.name})
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
